import { Card, Grid2 as Grid } from '@mui/material';

import { SuggestionCard } from '../../styled/SuggestionList.styled';

interface SuggestionListProps {
  onClick(input: string): void;
  suggestions: string[];
}

const SuggestionsList = ({ suggestions, onClick }: SuggestionListProps) => (
  <Grid container spacing={2}>
    {suggestions.map((suggestion) => (
      <Grid key={suggestion} size={{ md: 6, sm: 6, xs: 6 }}>
        <Card onClick={(event) => onClick(event.currentTarget.textContent!)}>
          <SuggestionCard>{suggestion}</SuggestionCard>
        </Card>
      </Grid>
    ))}
  </Grid>
);

export default SuggestionsList;
